/* 🤖 this file was generated by svg-to-ts */
export const matIconTour: {
  name: 'tour';
  data: string;
} = {
  name: 'tour',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M21 4H7V2H5v20h2v-8h14l-2-5 2-5zm-3.86 5.74.9 2.26H7V6h11.05l-.9 2.26-.3.74.29.74zM14 9c0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2 2 .9 2 2z"/></svg>`
};
